import { gql } from "@apollo/client";

export const VERIFY_SESSION = gql`
    mutation VerifySession($sessionId: String!) {
        verifySession(sessionId: $sessionId)
    }
`;
